import $ from 'jquery';

  $(function() {

    var minHeight = parseInt(0);

    $(".event-card__title").each(function(){
        if($(this).outerHeight() > minHeight){
            minHeight = $(this).outerHeight();
        }
    });
    $('.event-card__title').css('height', minHeight);

    $(".event-card__text").each(function(){
        if($(this).outerHeight() > minHeight){
            minHeight = $(this).outerHeight();
        }
    });
    $('.event-card__text').css('height', minHeight);
});


// WEBPACK FOOTER //
// ./components/cwm-event-card-signpost/scripts/event-card-signpost.js